import { Component } from '@angular/core';
import { ChatWidgetComponent } from './chat-widget/chat-widget.component';
import { ChatCustomization } from './models/customizations.model';
import { CustomizationService } from './services/customization.service';
import { AsyncPipe, NgIf } from '@angular/common';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [ChatWidgetComponent, NgIf, AsyncPipe],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  host: {
    'style': 'display: block; height: 100%;'
  }
})
export class AppComponent {
  title = 'chatbot-widget';
  customizations: Observable<ChatCustomization> | null = null;
  projectId: string | null = null;
  /** The widget this frame is: its look, and the one its usage is counted under. */
  widgetId: string | null = null;

  constructor(private customizationService: CustomizationService) {
    const params = new URLSearchParams(window.location.search);
    // Nubo.Api opens the frame with both ids, for every embed code, legacy ones included. ?projectId=
    // alone (or ?tenantId=) is a frame from a Nubo.Api older than widgets — see CustomizationService.
    this.widgetId = params.get('widgetId');
    this.projectId = params.get('projectId') || params.get('tenantId');

    // Store session token from URL (issued by widget proxy — no expiration)
    const widgetToken = params.get('widgetToken');
    if (widgetToken) {
      localStorage.setItem('widget-token', widgetToken);
    }

    this.customizations = this.customizationService.getCustomizations(this.widgetId, this.projectId);
  }
}